import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material'
import { ConfirmationData } from '../../models/confirm.model'

@Component({ templateUrl: 'confirm.dialog.html' })
export class ConfirmDialog {
  public closeData = {
    confirmed: true
  }
  constructor(
    public dialogRef: MatDialogRef<ConfirmDialog>,
    @Inject(MAT_DIALOG_DATA)
    public data: ConfirmationData
  ) { }
}
